var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3332 16.1666V8.03332C22.3332 7.49405 22.119 6.97687 21.7377 6.59555C21.3564 6.21423 20.8392 6 20.2999 6H4.03332C3.49405 6 2.97687 6.21423 2.59555 6.59555C2.21423 6.97687 2 7.49405 2 8.03332V22.2666H4.03332",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.334 20.2331V9.0498H26.4006C28.0184 9.0498 29.57 9.69248 30.714 10.8364C31.8579 11.9804 32.5006 13.532 32.5006 15.1498V20.2331C32.5006 20.7724 32.2864 21.2895 31.9051 21.6709C31.5237 22.0522 31.0066 22.2664 30.4673 22.2664H25.384",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4994 16.1664H28.4327C27.8935 16.1664 27.3763 15.9522 26.995 15.5709C26.6136 15.1896 26.3994 14.6724 26.3994 14.1331V9.0498",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3337 26.3334C24.0181 26.3334 25.3837 24.9678 25.3837 23.2834C25.3837 21.5989 24.0181 20.2334 22.3337 20.2334C20.6492 20.2334 19.2837 21.5989 19.2837 23.2834C19.2837 24.9678 20.6492 26.3334 22.3337 26.3334Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08368 26.3334C8.76814 26.3334 10.1337 24.9678 10.1337 23.2834C10.1337 21.5989 8.76814 20.2334 7.08368 20.2334C5.39922 20.2334 4.03369 21.5989 4.03369 23.2834C4.03369 24.9678 5.39922 26.3334 7.08368 26.3334Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2784 22.2666H10.1284",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.527403ae.svg";
export { ForwardRef as ReactComponent };